/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('SetSfwCtrl', function($scope, $cookies, $route) {
    $scope.sfw = 'true' === $cookies.get('sfw') ? true : false;

    return $scope.setSfw = function() {
        $scope.sfw   = !$scope.sfw;
        $cookies.put('sfw', $scope.sfw);
        return $route.reload();
    };
});
